const CONSTANTS = {
  GET_LOGIN_SEND_OTP_TO_USER: "GET_LOGIN_SEND_OTP_TO_USER",
  SET_LOGIN_SEND_OTP_TO_USER: "SET_LOGIN_SEND_OTP_TO_USER",

  GET_LOGIN_CHECK_OTP: "GET_LOGIN_CHECK_OTP",

  GET_MAIN_ACTIVE_BENEFITS: "GET_MAIN_ACTIVE_BENEFITS",
  SET_MAIN_ACTIVE_BENEFITS: "SET_MAIN_ACTIVE_BENEFITS",

  GET_MAIN_MY_POLICIES: "GET_MAIN_MY_POLICIES",
  SET_MAIN_MY_POLICIES: "SET_MAIN_MY_POLICIES",

  GET_MAIN_MY_DOCTOR: "GET_MAIN_MY_DOCTOR",
  SET_MAIN_MY_DOCTOR: "SET_MAIN_MY_DOCTOR",

  GET_MAIN_MY_MANAGER_BYPOLICYID: "GET_MAIN_MY_MANAGER_BYPOLICYID",
  SET_MAIN_MY_MANAGER_BYPOLICYID: "SET_MAIN_MY_MANAGER_BYPOLICYID",

  GET_MAIN_PLANNED_VISITS_DOCTOR: "GET_MAIN_PLANNED_VISITS_DOCTOR",
  SET_MAIN_PLANNED_VISITS_DOCTOR: "SET_MAIN_PLANNED_VISITS_DOCTOR",

  GET_MAIN_PLANNED_VISITS_SERVICE_CENTER:
    "GET_MAIN_PLANNED_VISITS_SERVICE_CENTER",
  SET_MAIN_PLANNED_VISITS_SERVICE_CENTER:
    "SET_MAIN_PLANNED_VISITS_SERVICE_CENTER",

  GET_MAIN_CHANGE_PASSWORD: "GET_MAIN_CHANGE_PASSWORD",
  SET_MAIN_CHANGE_PASSWORD: "SET_MAIN_CHANGE_PASSWORD",

  GET_MAIN_PERSONALINFO: "GET_MAIN_PERSONALINFO",
  SET_MAIN_PERSONALINFO: "SET_MAIN_PERSONALINFO",

  GET_MAIN_INSURANCE_PRODUCTS_BY_USER: "GET_MAIN_INSURANCE_PRODUCTS_BY_USER",
  SET_MAIN_INSURANCE_PRODUCTS_BY_USER: "SET_MAIN_INSURANCE_PRODUCTS_BY_USER",

  GET_MAIN_REMUNERATIONS_DASHBOARD: "GET_MAIN_REMUNERATIONS_DASHBOARD",
  SET_MAIN_REMUNERATIONS_DASHBOARD: "SET_MAIN_REMUNERATIONS_DASHBOARD",

  GET_MAIN_DASHBOARD_APPEALS: "GET_MAIN_DASHBOARD_APPEALS",
  SET_MAIN_DASHBOARD_APPEALS: "SET_MAIN_DASHBOARD_APPEALS",

  GET_MAIN_DELETE_RESERVATION: "GET_MAIN_DELETE_RESERVATION",
  SET_MAIN_DELETE_RESERVATION: "SET_MAIN_DELETE_RESERVATION",

  SET_MAIN_UPDATE_COUNTER: "SET_MAIN_UPDATE_COUNTER",
  GET_MAIN_FILE_DATA: "GET_MAIN_FILE_DATA",

  GET_FIND_CHILDREN: "GET_FIND_CHILDREN",
  SET_FIND_CHILDREN: "SET_FIND_CHILDREN",
  GET_ADDED_CHILDREN: "GET_ADDED_CHILDREN",
  SET_ADDED_CHILDREN: "SET_ADDED_CHILDREN",
  GET_ADD_CHILD: "GET_ADD_CHILD",
  SET_ADD_CHILD: "SET_ADD_CHILD",
  GET_CHECK_CHILD: "GET_CHECK_CHILD",
  SET_CHECK_CHILD: "SET_CHECK_CHILD",
  GET_INSURER_MOBILE: "GET_INSURER_MOBILE",
  SET_INSURER_MOBILE: "SET_INSURER_MOBILE",
  GET_SEND_OTP_INSURER: "GET_SEND_OTP_INSURER",
  SET_SEND_OTP_INSURER: "SET_SEND_OTP_INSURER",
  GET_SWITCH_USER: "GET_SWITCH_USER",
  SET_SWITCH_USER: "SET_SWITCH_USER",

  GET_MAIN_OPEN_USER_MODAL: "GET_MAIN_OPEN_USER_MODAL",
  SET_MAIN_OPEN_USER_MODAL: "SET_MAIN_OPEN_USER_MODAL",

  GET_MAIN_TECHICAL_MESSAGE: "GET_MAIN_TECHICAL_MESSAGE",
  SET_MAIN_TECHICAL_MESSAGE: "SET_MAIN_TECHICAL_MESSAGE",

  GET_MAIN_CANCEL_RESERVATION: "GET_MAIN_CANCEL_RESERVATION",

  GET_MAIN_ADD_RESERVATION_DOCUMENTS: "GET_MAIN_ADD_RESERVATION_DOCUMENTS",
  SET_MAIN_ADD_RESERVATION_DOCUMENTS: "SET_MAIN_ADD_RESERVATION_DOCUMENTS",

  GET_MAIN_QUESTION_STATUS: "GET_MAIN_QUESTION_STATUS",
  SET_MAIN_QUESTION_STATUS: "SET_MAIN_QUESTION_STATUS",

  GET_DOCTORS_CAN_CHANGE_PERSONAL_DOC: "GET_DOCTORS_CAN_CHANGE_PERSONAL_DOC",
  SET_DOCTORS_CAN_CHANGE_PERSONAL_DOC: "SET_DOCTORS_CAN_CHANGE_PERSONAL_DOC",

  SET_UPDATE_PLANNED_VISITS_DOCTOR: "SET_UPDATE_PLANNED_VISITS_DOCTOR",

  GET_NOTIFICATIONS_MAIN: "GET_NOTIFICATIONS_MAIN",
  SET_NOTIFICATIONS_MAIN: "SET_NOTIFICATIONS_MAIN",

  READ_NOTIFICATION_MAIN: "READ_NOTIFICATION_MAIN",

  GET_MAIN_IS_OUT_OF_OFFICE: "GET_MAIN_IS_OUT_OF_OFFICE",
  SET_MAIN_IS_OUT_OF_OFFICE: "SET_MAIN_IS_OUT_OF_OFFICE",

  GET_SHOW_SPECIALIST_POPUP: "GET_SHOW_SPECIALIST_POPUP",
  SET_SHOW_SPECIALIST_POPUP: "SET_SHOW_SPECIALIST_POPUP",

  GET_SENT_GRID_DATA_MAIN: "GET_SENT_GRID_DATA_MAIN",
  SET_SENT_GRID_DATA_MAIN: "SET_SENT_GRID_DATA_MAIN",
  SET_COMPENSATIONS_REQUEST_LOADING_MAIN:
    "SET_COMPENSATIONS_REQUEST_LOADING_MAIN",
  GET_SEND_REQUEST_COMPESATIONS_RETURNED_MAIN:
    "GET_SEND_REQUEST_COMPESATIONS_RETURNED_MAIN",
  SET_GRID_SIZE_VALIDATE_MAIN: "SET_GRID_SIZE_VALIDATE_MAIN",
  SET_POLICY_ID: "SET_POLICY_ID",
  GET_EXTEND_APPEAL: "GET_EXTEND_APPEAL",
  SET_EXTEND_APPEAL: "SET_EXTEND_APPEAL",
  SET_SCROLL_ID: "SET_SCROLL_ID",
};

export default CONSTANTS;
